module.exports = __webpack_public_path__ + "fonts/FiraGO-Bold.d1268097.otf";